// Countertops/Cabinets manual estimate — persistence action types.
// Follows the existing *_REQUEST / *_SUCCESS / *_FAILED feature-triad convention.

export const CC_ESTIMATE_SAVE_REQUEST = "@CC_ESTIMATE_SAVE_REQUEST";
export const CC_ESTIMATE_SAVE_SUCCESS = "@CC_ESTIMATE_SAVE_SUCCESS";
export const CC_ESTIMATE_SAVE_FAILED = "@CC_ESTIMATE_SAVE_FAILED";

export const CC_ESTIMATE_LOAD_REQUEST = "@CC_ESTIMATE_LOAD_REQUEST";
export const CC_ESTIMATE_LOAD_SUCCESS = "@CC_ESTIMATE_LOAD_SUCCESS";
export const CC_ESTIMATE_LOAD_FAILED = "@CC_ESTIMATE_LOAD_FAILED";

export const CC_ESTIMATE_STATE_CHANGE = "@CC_ESTIMATE_STATE_CHANGE";
